import { useEffect, useState } from "react";
import { whenFree } from "@/lib/popupQueue";
import { Ticket, PartyPopper } from "lucide-react";
import { api, imgSrc } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { confetti, playFanfare } from "@/lib/celebrate";

const KEY = "itz_seen_lotto_jackpot";
const busy = () => document.querySelector('[role="dialog"],[data-testid="lucky-wheel-modal"],[data-testid="level-up-modal"],[data-testid="jackpot-celebration"],[data-testid="scratch-big-celebration"],[data-testid="duel-celebration"],[data-testid="new-games-intro"]');

export function LottoJackpotCelebration() {
  const { user } = useAuth();
  const [ev, setEv] = useState(null);
  useEffect(() => {
    if (!user) return;
    const check = () => {
      if (document.visibilityState !== "visible" || busy()) return;
      api.get("/community/lotto-jackpot-latest").then(({ data }) => {
        if (!data || localStorage.getItem(KEY) === data.id) return;
        whenFree(`lotto-${data.id}`, () => {
          localStorage.setItem(KEY, data.id);
          setEv(data);
          playFanfare();
          [0, 300, 600, 900].forEach((d, i) => setTimeout(() => confetti({ x: innerWidth * (0.15 + 0.23 * i), y: innerHeight * 0.35, count: 110, spread: 1.7 }), d));
        });
      }).catch(() => {});
    };
    const t = setTimeout(check, 8000);
    const iv = setInterval(check, 30000);
    return () => { clearTimeout(t); clearInterval(iv); };
  }, [user?.user_id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!ev) return null;
  const p = ev.players[0];
  return (
    <div className="fixed inset-0 z-[88] flex items-center justify-center p-6 bg-rose-950/60 backdrop-blur-sm wheel-fade" data-testid="lotto-jackpot-celebration">
      <div className="relative w-full max-w-sm text-center levelup-pop">
        <span className="burst-rays !-inset-24" aria-hidden />
        <p className="relative text-xs font-extrabold uppercase tracking-[0.35em] text-pink-200">Lotto-Jackpot geknackt!</p>
        <div className="relative mx-auto mt-6 w-64 rounded-3xl border-4 border-pink-200 pink-gradient p-6 shadow-2xl shadow-rose-500/40 win-glow">
          <Ticket className="w-9 h-9 text-white mx-auto" />
          <p className="font-display text-5xl font-black text-white prize-pop" data-testid="lotto-jackpot-prize">{ev.prize.toLocaleString("de-DE")}</p>
          <p className="text-sm font-extrabold text-white/90">Punkte · 6 Richtige</p>
        </div>
        <div className="relative mt-5 flex items-center justify-center gap-3">
          {p.picture ? <img src={imgSrc(p.picture)} alt={p.name} className="w-11 h-11 rounded-full object-cover ring-4 ring-pink-200" />
            : <span className="w-11 h-11 rounded-full bg-white text-rose-600 font-extrabold flex items-center justify-center ring-4 ring-pink-200">{p.name?.[0]?.toUpperCase()}</span>}
          <span className="font-display text-xl font-extrabold text-white" data-testid="lotto-jackpot-name">{ev.me ? "Du hast gewonnen!" : ev.players.map((x) => x.name).join(" & ")}</span>
        </div>
        <button type="button" onClick={() => setEv(null)} data-testid="lotto-jackpot-close" className="relative mt-6 w-full h-12 rounded-full bg-white text-rose-600 font-extrabold inline-flex items-center justify-center gap-2 active:scale-95 transition-transform">
          <PartyPopper className="w-5 h-5" /> {ev.me ? "Juhu!" : "Glückwunsch!"}
        </button>
      </div>
    </div>
  );
}
